const { makeStyles } = require("@material-ui/core");

export const useStyles = makeStyles((theme) => ({
  pageHeaderWrap: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "15px 0px",
    borderRadius: "15px",
    gap: 20,
  },
  pageHeaderStacked: {
    flexDirection: "column",
    alignItems: "stretch",
    padding: "8px 0 0",
    gap: 8,
  },
  actionWrap: {
    marginLeft: "auto",
    display: "flex",
    alignItems: "center",
    gap: 5,
  },
  actionWrapStacked: {
    width: "100%",
    marginLeft: 0,
    flex: "1 1 100%",
  },
  actionCustomContentStacked: {
    width: "100%",
    flex: "1 1 100%",
  },
  header: {
    ...theme.typography.h4,
    ...theme.typography.semiBold,
    ...theme.secondaryColor,
  },
  linkHeader: {
    ...theme.typography.breadCrumb,
  },
  linkActiveHeader: {
    ...theme.typography.breadCrumb,
    ...theme.typography.semiBold,
    ...theme.secondaryColor,
    color: `#0028fa`,
  },
  list: {
    display: "flex",
    alignItems: "center",
    listStyle: "none",
    margin: 0,
    padding: 0,
    width: "100%",
  },
  listItem: {
    background: "#fff",
    padding: "6px 20px",
    ...theme.typography.b1,
    cursor: "pointer",
    "&:not(:first-child)": {
      borderLeft: "1px solid #bebebe",
      paddingLeft: 20,
    },
    "&:not(:last-child)": {
      paddingRight: 20,
    },
    display: "flex",
    gap: 4,
    alignItems: "center",
    whiteSpace: "pre",
    justifyContent: "center",
  },
  listCount: {
    ...theme.typography.b1,
    ...theme.typography.semiBold,
  },
  listItemSelected: {
    fontWeight: 700,
    textDecoration: "underline",
    textUnderlineOffset: "3px",
    backgroundColor: "#C5E3FF",
  },
  bg0: {
    backgroundColor: "#EAF5FF",
  },
  bg1: {
    backgroundColor: "#C5E3FF", // Prospectin
  },
  bg2: {
    backgroundColor: "#9CD0FF", // First Contact
  },
  bg3: {
    backgroundColor: "#f5d6b6", // Viewing
  },
  bg4: {
    backgroundColor: "#FFB800", // Viewing Contact
  },
  bg5: {
    backgroundColor: "#a9d7bb", // Assessment
  },
  bg6: {
    backgroundColor: "#70BB63", // Assessment Outcome
  },
  bg7: {
    backgroundColor: "#C4C4C4", // Close
  },
  infoWrap: {
    backgroundColor: "#EAF5FF",
    padding: 8,
    borderRadius: 4,
    display: "flex",
    alignItems: "center",
    gap: 5,
  },
  filterWrap: {
    overflowX: "auto",
    display: "flex",
    justifyContent: "space-between",
    "&::-webkit-scrollbar": {
      height: 2,
    },
  },
  titleWrap: {
    display: "flex",
    gap: 18,
  },
  titleWrapStacked: {
    width: "100%",
    flex: "1 1 auto",
  },
  titleRowStacked: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    gap: 12,
  },
  timeline: {
    marginBottom: 18,
    position: "sticky",
    top: "10px",
  },
  fixedItem: {
    width: "12%",
  },
  timelineClear: {
    marginBottom: 0,
  },
  fixedItemLG: {
    width: "16%",
  },
  viewWrap: {
    borderRight: "2px solid #aeadad",
    paddingRight: 10,
    marginRight: 5,
  },
}));
